import { useState, useEffect } from 'react';

declare global {
  interface Window {
    Telegram?: {
      WebApp?: {
        initData?: string;
        ready?: () => void;
        expand?: () => void;
        close?: () => void;
        MainButton?: {
          text: string;
          color: string;
          textColor: string;
          isVisible: boolean;
          isActive: boolean;
          isProgressVisible: boolean;
          setText: (text: string) => void;
          onClick: (callback: () => void) => void;
          offClick: (callback: () => void) => void;
          show: () => void;
          hide: () => void;
          enable: () => void;
          disable: () => void;
          showProgress: (leaveActive?: boolean) => void;
          hideProgress: () => void;
        };
        BackButton?: {
          isVisible: boolean;
          onClick: (callback: () => void) => void;
          offClick: (callback: () => void) => void;
          show: () => void;
          hide: () => void;
        };
        platform?: string;
        colorScheme?: string;
        themeParams?: Record<string, string>;
      };
    };
  }
}

export const usePlatform = (): string => {
  const [platform, setPlatform] = useState<string>('web-desktop');

  useEffect(() => {
    // Проверяем наличие Telegram WebApp объекта
    if (
      typeof window !== 'undefined' &&
      window.Telegram &&
      window.Telegram.WebApp &&
      window.Telegram.WebApp.initData
    ) {
      setPlatform('telegram');
      return;
    }

    // Проверяем мобильные устройства
    const isMobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent,
      );

    if (isMobile) {
      setPlatform('web-mobile');
    } else {
      setPlatform('web-desktop');
    }
  }, []);

  return platform;
};
